import Vue from 'vue'
import Vuex from 'vuex'
import globals from '../globals'
import axios from 'axios'
import firebase from 'firebase'

Vue.use(Vuex)

const state = {
  user: null,
  settings: null,
  legend: false
}

const mutations = {
  setUser (state, payload) {
    state.user = payload
  },
  removeUser (state) {
    state.user = null
  },
  setSettings (state, settings) {
    state.settings = {...state.settings, ...settings}
  },
  setLegend (state, legend) {
    state.legend = [...legend]
  }
}

const actions = {
  login ({ commit }, uid) {
    return axios.get(`${globals().publicApiUrl}/admin-users?uid=${uid}`, { headers: {'Authentication': globals().getToken()} }).then((data) => {
      if (data.data.length > 0 && data.data[0].id && data.data[0].uid) {
        var user = data.data[0];

        user.permissions = [];

        axios.get(`${globals().publicApiUrl}/admin-users/users-groups`, { headers: {'Authentication': globals().getToken()} }).then((data) => {
          data.data.forEach( (group) => {
            if (user.groups.includes(group.group_uid)){
              const permissions = group.permissions

              permissions.forEach( (permission) => {
                if (!user.permissions.includes(permission)){
                  user.permissions.push(permission)
                }
              })
            }
          })
        }).catch((err) => { console.log(err) })

        commit('setUser', user)        
        // commit('setUser', data.data[0])
      } else {
        return Promise.reject('Not found user')
      }
    }).catch((err) => {
      throw err
    })
  },
  logout: ({ commit }) => commit('removeUser'),
  async getPortalSettings({ commit }, portalId, cb = null) {
    try {
      const req = await axios.get(`${globals().publicApiUrl}/settings/${portalId}`, { headers: {'Authentication': globals().getToken()} })
  
      if (req.status >= 200 && req.status < 400) {
        const response = req.data
        const settings = response.length ? response[0] : null

        if (settings) {
          const newSettings = {}
          newSettings[portalId] = settings
          commit('setSettings', newSettings)

          if (cb) {
            cb();
          }
        }
        
      }

    } catch (e) {

    }
  },
  setLegend: ({commit}, legend) => commit('setLegend', legend)

}

const getters = {
  isLogged: state => {
    if (!firebase.auth().currentUser || !state.user || !state.user.id) {
      return false
    }
    return true
  }
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})
